export const imageFormats = {
  jpg: { mime: 'image/jpg', density: 1 },
  webp: { mime: 'image/webp', density: 1.5 },
};
